import axios from 'axios';
import mqtt from 'mqtt';
import { QueueNumberDTO } from '../interface/interface';

export interface CallerConfigDTO {
  callerType: string;
  title: string;
  description:string;
  callerId: string;
  playList: PatientCallerPlayListElementDTO[];
}

export interface PatientCallerPlayListElementDTO {
  item: number;
  description: string;
  source: string;
  type: string;
  timeout: number;
  youtube: boolean;
  external: boolean;
}

export interface SiteInfoDTO {
  siteuuid: string;
  sitename: string;
  siteid: number;
}

export interface RabbitConfigDTO{
  host: string;
  username: string;
  password: string;
  port: number;
}

const BASE_URL = `${window.location.origin}/api/public/patientcallercontroller`;

let mqttClient: mqtt.MqttClient | null = null;

export interface RabbitConfigDTO {
  host: string;
  username: string;
  password: string;
  port: number;
}

/**
Suscripción a la cola de QueueNumbers

onNewQueue: se dispara cuando se crea un número 
onPatientCall : se dispara cuando la secretaria / médico lo “llama”
 */
export const connectToQueueNumberQueue = async (
  siteUuid: string,
  hospitalLocationId: number,
  onNewQueue:   (qn: QueueNumberDTO) => void,
  onPatientCall?: (qn: QueueNumberDTO) => void,
  onQueueDeactivate?: (qn: QueueNumberDTO) => void
) => {

  const { host, port, username, password } = await fetchRabbitConfig();

  const topic = `${siteUuid}-queuenumber-${hospitalLocationId}`;
  const wsUrl = `wss://${host}:${port}/ws`;

  mqttClient = mqtt.connect(wsUrl, {
    clientId: `react_${Math.random().toString(16).slice(2)}`,
    username,
    password,
    reconnectPeriod: 5000,
    connectTimeout: 4000,
  });

  mqttClient.on('connect', () => {
    mqttClient?.subscribe(topic, { qos: 1 }, err =>
      err && console.error('[MQTT] error al suscribir:', err)
    );
  });

  mqttClient.on('message', (_, raw) => {
    let payload: any;
    try {
      payload = JSON.parse(raw.toString());
    } catch {
      console.error('[MQTT] JSON inválido:', raw.toString());
      return;
    }

    // Compatibilidad: si no viene “event”, asumimos queue-created
    const event = payload.event ?? 'queue-created';
    const data  = payload.data  ?? payload;

    switch (event) {
      case 'queue-created':
        onNewQueue?.(data as QueueNumberDTO);
        break;

      case 'patient-called':
        onPatientCall?.(data as QueueNumberDTO);
        break;

      case 'queue-deactivated':                    // ← NUEVO
        onQueueDeactivate?.(data as QueueNumberDTO);
      break;

      default:
        console.warn('[MQTT] evento desconocido:', event, payload);
    }
  });

  mqttClient.on('error', (err) => console.error('[MQTT] error de conexión:', err));
  mqttClient.on('offline', () => console.warn('[MQTT] broker offline'));
};

export const fetchCallerInfo = async (callerid: number): Promise<CallerConfigDTO> => {
  const response = await axios.get<CallerConfigDTO>(`${BASE_URL}/loadCallerInfo`, {
    params: { callerid },
  });
  return response.data;
};

export const fetchSiteInfo = async (): Promise<SiteInfoDTO> => {
  const response = await axios.get<SiteInfoDTO>(`${BASE_URL}/loadSiteInfo`);
  return response.data;
};

export const fetchRabbitConfig = async (): Promise<RabbitConfigDTO> => {
  const response = await axios.get<RabbitConfigDTO>(`${BASE_URL}/fetchRabbitConfig`);
  return response.data;
};